import React, { Children } from "react";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import Image from "@components/item/Image";

interface IContainer {
  outlined: boolean;
  point: boolean;
  big: boolean;
  height: string;
  width: string;
  noBorder: boolean;
  disabled: boolean;
  radius?: string;
  borderColor?: string;
  padding?: string;
  fit?: boolean;
  warning?: boolean;
  transparent?: boolean;
  gray?: boolean;
  minttransparent?: string;
  bgColor?: string;
  active?: boolean;
  gap?: string;
  fontSize?: string;
  mint?: boolean;
}
const Container = styled.button<IContainer>(
  ({
    theme,
    outlined,
    point,
    big,
    height,
    width,
    noBorder,
    disabled,
    radius,
    borderColor,
    padding,
    fit,
    warning,
    transparent,
    gray,
    bgColor,
    active,
    gap,
    fontSize,
    mint,
  }) => ({
    width: fit ? "fit-content" : width,
    height: big ? "5.2rem" : height,
    textWrap: "nowrap",
    display: "flex",
    gap: gap ? gap : "0.4rem",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: theme.fontWeight.medium,
    padding: padding ? padding : "1rem 2rem",
    backgroundColor: active
      ? "rgba(62, 255, 179, 0.1)"
      : bgColor
        ? bgColor
        : transparent
          ? "transparent"
          : disabled
            ? theme.color.light_gray
            : point
              ? theme.color.mint
              : warning
                ? theme.color.orange
                : outlined
                  ? theme.color.white
                  : theme.color.black,

    color: mint
      ? theme.color.mint
      : disabled
        ? theme.color.white
        : point
          ? theme.color.black
          : gray
            ? theme.color.light_gray
            : outlined || transparent
              ? theme.color.black
              : theme.color.white,

    border: active
      ? `1px solid ${theme.color.mint}`
      : (outlined && noBorder) || disabled
        ? "none"
        : borderColor
          ? `1px solid ${borderColor ? borderColor : theme.color.black}`
          : "none",

    cursor: "pointer",
    borderRadius: radius ? radius : "0",
    fontSize: fontSize ? fontSize : "1.4rem",
  }),
);

const Icon = styled.div({
  // paddingBottom: "0.4rem",
});

type Props = {
  title: string;
  outlined?: boolean;
  onClick?: () => void;
  point?: boolean;
  big?: boolean;
  height?: string;
  width?: string;
  icon?: string;
  noBorder?: boolean;
  disabled?: boolean;
  radius?: string;
  borderColor?: string;
  padding?: string;
  fit?: boolean;
  warning?: boolean;
  type?: "button" | "submit" | "reset";
  transparent?: boolean;
  gray?: boolean;
  bgColor?: string;
  active?: boolean;
  children?: React.ReactNode;
  gap?: string;
  fontSize?: string;
  mint?: boolean;
};
const BasicButton = ({
  title,
  outlined = false,
  onClick,
  point = false,
  big = false,
  height = "4.4rem",
  width = "",
  icon,
  noBorder = false,
  disabled = false,
  radius,
  borderColor,
  padding,
  fit = false,
  warning = false,
  type = "button",
  transparent = false,
  gray = false,
  bgColor,
  active = false,
  children,
  gap,
  fontSize,
  mint = false,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Container
      outlined={outlined}
      onClick={onClick}
      point={point}
      big={big}
      fit={fit}
      warning={warning}
      noBorder={noBorder}
      disabled={disabled}
      radius={radius}
      height={height}
      width={width}
      padding={padding}
      borderColor={borderColor}
      type={type}
      transparent={transparent}
      gray={gray}
      active={active}
      bgColor={bgColor}
      gap={gap}
      fontSize={fontSize}
      mint={mint}>
      {t(title)}
      {children}
      {icon && (
        <Icon>
          <Image src={icon} width="1.6rem" height="1.6rem" />
        </Icon>
      )}
    </Container>
  );
};

export default BasicButton;
